export default "__VITE_ASSET__0337d2b2__"